<div class="comment-annotation-component" [hidden]="true">
  <div class="toolbar w-100 d-flex">
    <div
      class="editor-container flex-fill align-items-start d-none">
      <mtm-user-profile-picture
        [username]="authUser?.username"
        [height]="28"
        [width]="28"
        class="d-flex align-items-center m-2">
      </mtm-user-profile-picture>
      <mtm-comment-editor
        [(value)]="annotationComment"
        [files]="files"
        [videoRecordFiles]="videoRecordFiles"
        [audioRecordFiles]="videoRecordFiles"
        (fileDelete)="onFileDeleted($event)"
        (fileUpload)="uploadFileCallback($event)"
        (cancelClick)="cleanUp()"
        (submit)="addNewAnnotation()"
        (enterKeyPress)="addNewAnnotation()"
        [placeholder]="getPlaceholderText()"
        (keyup)="$event.stopPropagation()"
        (editorClick)="startAnnotationMode()"
        [cancelButtonEnabled]="annotatingMode"
        [saveButtonEnabled]="annotatingMode"></mtm-comment-editor>
    </div>
    <mtm-file-download-control
      [file]="item"
      [displayType]="'icon'"
      #downloadButton
      [iconSize]="24"
      [lightIcon]="true"
      [iconColor]="'white'"
      style="display: none"
      [uniqueControlId]="`${item.projectId}-${item.sectionId}-${item.subSectionId}-${item.id}`"
      [iconUrl]="'../../../../../assets/img/annotations/download.png'">
    </mtm-file-download-control>
    <!--
        <div [ngClass]="{'disabledButton': isInValidInput() === true}"
            (click)="$event.preventDefault();addNewAnnotation()" class="toolbarOptions save-button pt-2 pb-2 ps-1 pe-1">
            <span class="tooltiptext" directiveCommentMinButtons>{{ 'saveAnnotation' | translate
                }}</span>
            <img src="../../../../../assets/img/annotations/annot_send.svg" alt="" height="24">
        </div>
        -->
  </div>
</div>
